import BaseService from '@/api/checkInBase';
import {
  ReducerState,
  MainState,
  RentRecordInfo,
  AdjustRecordInfo,
  storeName,
} from '@/redux/reducers/reservation/checkOut';
import { CheckOutAction } from './constant';

import { createActionMiddleware } from './helper';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

// 更新初始化状态
const setInitStatus = (isInit: boolean) => {
  return { type: CheckOutAction.setInitStatus, payload: isInit };
};

// 更新loading状态
export const setLoadingStatus: (isLoading: boolean) => void = (isLoading) => {
  return {
    type: CheckOutAction.setLoadingStatus,
    payload: isLoading,
  };
};

// 更新房卡管理状态
const getCardManageStatus = () => {
  return async (dispatch) => {
    try {
      const res = await BaseService.getCardStatus();
      dispatch({
        type: CheckOutAction.setCardStatus,
        payload: !!res.data,
      });
    } catch (e) {
      //
    }
  };
};

// 页面初始化
export const initPageState: (initFunc: () => Promise<MainState>) => void = (initFunc) => {
  return async (dispatch) => {
    try {
      // 未初始化状态
      dispatch({
        type: CheckOutAction.initDefaultState,
        payload: <MainState>{
          isInit: false,
          isLoading: true,
          cardEnabled: false,
          rentRoomList: [],
          roomGuestList: [],
          overtimePriceAdjustList: [],
          peripheralRoomInventoryList: [],
        },
      });
      dispatch(getCardManageStatus());
      // 调用初始化方法
      const initState = await initFunc();
      // 设置初始化数据
      dispatch({ type: CheckOutAction.initDefaultState, payload: initState });
      dispatch(setInitStatus(true));
      dispatch(setLoadingStatus(false));
    } catch (_) {
      dispatch(setInitStatus(false));
    }
  };
};

// 外设归还-item change
export const handlePeripheralReturnItemChange: (updateList: any) => void = (updateList) => {
  return actionWrapper((dispatch) => {
    dispatch({
      type: CheckOutAction.setPeripheralReturnList,
      payload: updateList,
    });
  });
};

// 更新房间列表信息
export const updateRentRoomList: (updateValue: RentRecordInfo[]) => void = (updateValue) => {
  return actionWrapper((dispatch) => {
    dispatch({
      type: CheckOutAction.setRentRoomList,
      payload: updateValue,
    });
  });
};

export const updateAdjustRecordItem: (
  indexId: string,
  updateValue: Partial<RentRecordInfo>,
) => void = (indexId, updateValue) => {
  return actionWrapper((dispatch, getState) => {
    const { overtimePriceAdjustList, rentRoomList } = getState();
    const key = Object.keys(updateValue)[0];
    if (key === 'overtimePrice') {
      let updateList = [...overtimePriceAdjustList];
      const exsist = overtimePriceAdjustList.find((item) => item.indexId === indexId);
      const currentItem = rentRoomList.find((item) => item.indexId === indexId);
      if (exsist) {
        updateList = updateList.map((item) => {
          if (item.indexId === indexId)
            return {
              ...item,
              ...updateValue,
              adjustPrice: `-${
                Number(item?.overtimePriceReceivable) - Number(updateValue?.overtimePrice)
              }`,
            };
          return item;
        });
      } else {
        // 有几个“[实际加收超时房费] ＜ [应加收超时房费]”的场景，这里就出现几条对应的记录
        if (Number(currentItem?.overtimePrice) - Number(currentItem?.overtimePriceReceivable) < 0) {
          updateList.push({
            ...currentItem,
            adjustPrice: `-${
              Number(currentItem?.overtimePriceReceivable) - Number(currentItem?.overtimePrice)
            }`,
            adjustReason: '',
            adjustRemarks: '',
          });
        }
      }
      // 修改实际
      dispatch({
        type: CheckOutAction.setOvertimePriceAdjustList,
        payload: updateList,
      });
    }
  });
};

// 房间信息修改
export const handleRecordItemChange: (
  indexId: string,
  updateValue: Partial<RentRecordInfo>,
) => void = (indexId, updateValue) => {
  return actionWrapper((dispatch, getState) => {
    const { rentRoomList } = getState();
    const key = Object.keys(updateValue)[0];
    dispatch(updateAdjustRecordItem(indexId, updateValue));
    dispatch(
      updateRentRoomList(
        rentRoomList.map((item) => {
          if (item.indexId === indexId) {
            return {
              ...item,
              ...updateValue,
            };
          }
          return item;
        }),
      ),
    );
  });
};

// 超时房费冲调信息修改
export const updateOvertimePriceAdjustList: (updateValue: RentRecordInfo[]) => void = (
  updateValue,
) => {
  return actionWrapper((dispatch) => {
    dispatch({
      type: CheckOutAction.setOvertimePriceAdjustList,
      payload: updateValue,
    });
  });
};
export const handleOverTimeRecordItemChange: (
  indexId: string,
  updateValue: Partial<AdjustRecordInfo>,
) => void = (indexId, updateValue) => {
  return actionWrapper((dispatch, getState) => {
    const { overtimePriceAdjustList } = getState();

    dispatch(
      updateOvertimePriceAdjustList(
        overtimePriceAdjustList.map((item) => {
          if (item.indexId === indexId) {
            return {
              ...item,
              ...updateValue,
            };
          }
          return item;
        }),
      ),
    );
  });
};

// 更新房卡数量
export const refreshRoomCardCount: (updateValue: { [roomId: string]: number }) => void = (
  updateValue,
) => {
  return actionWrapper((dispatch, getState) => {
    const { rentRoomList } = getState();
    dispatch(
      updateRentRoomList(
        rentRoomList.map((item) => {
          return {
            ...item,
            roomCardCount: updateValue[item.roomId] || item.roomCardCount,
          };
        }),
      ),
    );
  });
};

// 获取全部状态
export const getMainState: (callback: (state: ReducerState) => void) => void = (callback) => {
  return actionWrapper((_, getState) => {
    try {
      callback(getState());
    } catch (e) {
      //
    }
  });
};
